import { useMemo } from 'react';

import { useDebouncedValue } from '../Meta/useDebouncedValue';
import {
  ISmsLinkDraft,
  ISmsLinkInput,
  STUDENT_SMS_PREVIEW_DEBOUNCE_MS,
  smsLinkInput,
} from './smsModel';

export interface ISmsPreviewInput {
  text: string;
  link: ISmsLinkInput | null;
}

export interface IUseSmsPreviewInput {
  /** Что уходит в предпросмотр — после задержки. */
  debounced: ISmsPreviewInput;
  /** Предпросмотр отстал от набранного (задержка ещё идёт). */
  lagging: boolean;
  /** Набрано ли вообще что-то. */
  hasText: boolean;
}

/**
 * Текст и ссылка для предпросмотра — с задержкой, чтобы каждая буква не
 * была запросом.
 *
 * 🔴 Задерживается СТРОКА, а не объект: объект ссылки собирается заново на
 * каждый рендер, и `useDebouncedValue` от него перезапускал бы таймер без
 * конца — предпросмотр перечитывался бы каждые 400 мс вечно.
 */
export const useSmsPreviewInput = (
  text: string,
  link: ISmsLinkDraft,
): IUseSmsPreviewInput => {
  const trimmed = text.trim();
  const key = JSON.stringify({ text: trimmed, link: smsLinkInput(link) });
  const debouncedKey = useDebouncedValue(key, STUDENT_SMS_PREVIEW_DEBOUNCE_MS);
  const debounced = useMemo<ISmsPreviewInput>(
    () => JSON.parse(debouncedKey) as ISmsPreviewInput,
    [debouncedKey],
  );
  return {
    debounced,
    lagging: debouncedKey !== key,
    hasText: Boolean(trimmed),
  };
};
